export default "__VITE_ASSET__azNBukVS__"